export default async({ store }) => {
  await store.dispatch('site/getSiteInfo')
  await store.dispatch('site/getWebSiteInfo')
}
